import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { type SelectProps } from '@mui/material/Select';

import type { AllRepeatDetails } from '../Repeat.types';
import { getLabelSize } from '../utils';

interface SelectDayCalendarProps {
  value: AllRepeatDetails;
  onChange: (value: AllRepeatDetails) => void;
  maxDaysInMonth: number;
  disabled: boolean;
  inputSize: 'small' | 'medium';
  inputVariant: SelectProps['variant'];
}
const sxMinWidth = { minWidth: 120 };

const SelectDayCalendar = ({
  value,
  onChange,
  maxDaysInMonth,
  disabled,
  inputSize,
  inputVariant,
}: SelectDayCalendarProps) => {
  const labelSize = getLabelSize(inputSize);
  return (
    <FormControl fullWidth>
      <InputLabel id="select-day-cal-label" disabled={disabled} size={labelSize}>
        Select Day
      </InputLabel>
      <Select
        sx={sxMinWidth}
        {...{ size: inputSize, disabled: disabled }}
        onChange={(e) =>
          onChange({
            ...value,
            byMonthDay: [Number.parseInt(e.target.value as string, 10)],
          })
        }
        value={value.byMonthDay && value.byMonthDay.length > 0 ? value.byMonthDay : ''}
        labelId="select-day-cal-label"
        label="Select Day"
        variant={inputVariant}
      >
        <MenuItem value="" key={0} disabled>
          None
        </MenuItem>
        {Array.from({ length: maxDaysInMonth }, (_, i) => i + 1).map((day) => (
          <MenuItem key={day} value={day}>
            {day}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectDayCalendar;
